import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { Reveal } from './Reveal';
const BLOCKS = [{
  title: 'Driven by passion',
  text: 'We work closely with our clients to craft unique brand stories and visual elements that capture the essence of their business.',
  stat: '+ 90',
  label: 'Satisfied Customers'
}, {
  title: 'Professional talent',
  text: 'Our team of experts combines creativity with cutting-edge technology to deliver customized solutions that resonate with your target audience.',
  stat: '+ 96',
  label: 'Project completed'
}];
export function About() {
  return <section id="about" className="mx-auto w-full max-w-7xl px-5 py-24 lg:px-8" data-id="element-13" data-mp="3dhl0l6jxa513">
      <SectionEyebrow label="About Studio Web VIP" data-id="element-14" data-mp="3hhlf0r70ug85" />
      <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-2" data-id="element-15" data-mp="3hkhewl2fjez8">
        <div data-id="element-16" data-mp="3mjanq06ruht2">
          <Reveal anim="slideInLeft" data-id="element-17" data-mp="3mfmxb9wmibik">
            <h2 className="font-heading text-4xl uppercase leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-18" data-mp="3rgayupihaar1">Elevating Brands in the Digital World</h2>
          </Reveal>
          <Reveal anim="slideInLeft" className="mt-8" data-id="element-19" data-mp="2lourl3udyldr">
            <a href="#services" className="inline-flex items-center gap-2 font-bold uppercase tracking-wider text-[#FFB700] hover:text-white" data-id="element-20" data-mp="2grcr81ufpehd">Explore our Services <ArrowRightIcon className="h-4 w-4" data-id="element-21" data-mp="27rfx3kp9znex" /></a>
          </Reveal>
        </div>
        <Reveal anim="slideInUp" data-id="element-22" data-mp="27titcmh0ucs3">
          <p className="text-lg leading-relaxed text-[#B2B2B2]" data-id="element-23" data-mp="34i8c0f0h39f4">
            Studio Web VIP is a premier digital agency specializing in <span className="text-white" data-id="element-24" data-mp="30hepnq2oi2oc">lead generation</span>, <span className="text-white" data-id="element-25" data-mp="2vpeueaxjzxy3">digital marketing campaigns</span> focused on Facebook Ads, TikTok Ads, Instagram Ads, and more. We are passionate about helping businesses create a strong online presence and visually stunning digital experiences.
          </p>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-26" data-mp="3jezg31l3d9b2">
        {BLOCKS.map((b, i) => <Reveal key={b.title} anim="fadeInUp" delay={i * 0.15} data-id="element-27" data-mp="65tycjj1oihi" data-mpi={i}>
            <div className="flex h-full items-start justify-between gap-6 rounded-2xl border border-white/10 bg-[#1b1b1b] p-8" data-id="element-28" data-mp="66lvvzw7cqaf">
              <div data-id="element-29" data-mp="3tiwcg9t9vtyq">
                <h4 className="font-heading text-xl uppercase text-white" data-id="element-30" data-mp="3tjfwbw2hgsfe">{b.title}</h4>
                <p className="mt-3 text-[15px] leading-relaxed text-[#B2B2B2]" data-id="element-31" data-mp="1evh9hq8fgd7">{b.text}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-32" data-mp="3jk72r4bj5ftk">
                <p className="font-heading text-4xl text-[#FFB700]" data-id="element-33" data-mp="3jjfao3h56081">{b.stat}</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-[#B2B2B2]" data-id="element-34" data-mp="3okmj84r3z3fr">{b.label}</p>
              </div>
            </div>
          </Reveal>)}
      </div>
    </section>;
}